import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  analysisIdInputSchema,
  analysisListSchema,
  analysisSchema,
  countSchema,
  emptyInputSchema,
  moveInputSchema,
  recentAnalysesInputSchema,
  recentAnalysesSchema,
  removeInputSchema,
  renameInputSchema,
  searchTargetsInputSchema,
  startInputSchema,
  targetListSchema,
  updateSettingsInputSchema,
  updateWizardInputSchema,
} from "./analysis.schemas.ts";

export const analysisTrpcContract = defineTrpcContract("analysis", {
  list: query({ input: emptyInputSchema, output: analysisListSchema }),
  recent: query({ input: recentAnalysesInputSchema, output: recentAnalysesSchema }),
  get: query({ input: analysisIdInputSchema, output: analysisSchema }),
  searchTargets: query({ input: searchTargetsInputSchema, output: targetListSchema }),
  create: mutation({ input: emptyInputSchema, output: analysisSchema }),
  updateWizard: mutation({ input: updateWizardInputSchema, output: analysisSchema }),
  start: mutation({ input: startInputSchema, output: analysisSchema }),
  pause: mutation({ input: analysisIdInputSchema, output: analysisSchema }),
  rename: mutation({ input: renameInputSchema, output: analysisSchema }),
  updateSettings: mutation({ input: updateSettingsInputSchema, output: analysisSchema }),
  remove: mutation({ input: removeInputSchema, output: countSchema }),
  moveToProject: mutation({ input: moveInputSchema, output: countSchema }),
});
